import Vapi from 'vuex-rest-api'
import http from 'src/http/index'
import { createSuccess, updateSuccess } from 'components/utils/storeUtils'

const initialState = () => ({
  ihm_register_organisaties: null,
  ihm_register_organisatie: {},
  ihm_register_users: null,
  ihm_resgister_user: {}
})

const ihmRegister = new Vapi({
  axios: http.axios,
  baseURL: process.env.API_URL + '/ihm_register',
  queryParams: true,
  state: initialState()
}).post({
  action: 'CREATE_IHM_REGISTER_ORGANISATIE',
  property: 'ihm_register_organisatie',
  path: 'ihm_register_organisatie',
  queryParams: true,
  onSuccess: createSuccess('ihm_register_organisatie', 'ihm_register_organisaties')
}).post({
  action: 'CREATE_IHM_REGISTER_USER',
  property: 'ihm_register_user',
  path: 'ihm_register_user',
  queryParams: true,
  onSuccess: createSuccess('ihm_register_user', 'ihm_register_users')
}).post({
  action: 'UPDATE_IHM_REGISTER_USER',
  property: 'ihm_register_user',
  path: ({ id }) => `/ihm_register_user/${id}`,
  onSuccess: updateSuccess('ihm_register_user', 'ihm_register_users')
}).getStore()

ihmRegister.mutations.RESET_IHM_REGISTER_STATE = (state) => {
  const initial = initialState()
  for (const key in state) {
    if (Object.prototype.hasOwnProperty.call(state, key)) {
      state[key] = initial[key]
    }
  }
}

export default ihmRegister
